module.exports = __webpack_public_path__ + "static/goodFriday-5cfeefebc5271bde87542721479af124.png";